import { Modal } from "antd";

// A guest who tries to join the championship goes straight to creating an account.
export const isGuestMustRegisterError = (error) =>
  error?.response?.data?.code === "GUEST_MUST_REGISTER";

export const openGuestChampionshipRegister = (navigate) => {
  Modal.confirm({
    centered: true,
    title: "Crea tu cuenta para unirte al campeonato",
    content:
      "Los invitados no pueden inscribirse. Crea tu cuenta gratis con tu correo: lo que jugaste como invitado se guarda en tu cuenta.",
    okText: "Crear cuenta",
    cancelText: "Ahora no",
    onOk: () => navigate("/register?upgrade=1&returnTo=%2Fgame%2Fchampionship"),
  });
};
